export const common = {
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    facility: 'Facility & Security',
    blog: 'Knowledge Center',
    contact: 'Contact',
    getQuote: 'Get Quote',
    callNow: 'Call Now',
    whatsapp: 'WhatsApp'
  },
  hero: {
    title: 'Reliable Warehouse and Logistics Services Connected to Muratbey Customs',
    subtitle: 'Fast, secure and transparent solutions for your bonded/non-bonded storage, transit and logistics operations.',
    quickQuoteTitle: 'Quick Quote Form'
  },
  form: {
    fullName: 'Full Name',
    company: 'Company',
    phone: 'Phone',
    email: 'Email',
    service: 'Service Selection',
    message: 'Message',
    kvkk: 'I have read and accept the privacy policy',
    submit: 'Request Quote',
    selectService: 'Select service'
  },
  services: {
    title: 'Our Services',
    subtitle: 'Customized Logistics Solutions',
    viewDetails: 'View Details',
    customsWarehouse: {
      title: 'Bonded General Warehouse',
      benefits: [
        'Import tax savings',
        '24/7 online tracking system',
        'Fast customs procedures'
      ]
    },
    freeWarehouse: {
      title: 'Free Zone / Non-Bonded Storage',
      benefits: [
        'Flexible storage periods',
        'Modern facility and equipment',
        'Secure inventory management'
      ]
    },
    transit: {
      title: 'Transit Services',
      benefits: [
        'Fast transit procedures',
        'International experience',
        'Comprehensive documentation'
      ]
    },
    hazardous: {
      title: 'Hazardous Materials Storage',
      benefits: [
        'Special security measures',
        'Licensed storage',
        'Expert personnel'
      ]
    },
    valueAdded: {
      title: 'Value Added Services',
      benefits: [
        'Packaging and labeling',
        'Barcode systems',
        'Consolidation services'
      ]
    },
    customs: {
      title: 'Customs Clearance',
      benefits: [
        'Professional customs consulting',
        'Fast processing',
        'Full compliance guarantee'
      ]
    }
  },
  whyUs: {
    title: 'Why Piramit?',
    subtitle: 'Trust and Quality Focused Service',
    quality: {
      title: 'Quality and Trust',
      desc: 'ISO 9001 standard procedures and continuous improvement'
    },
    transparency: {
      title: 'Transparent Reporting',
      desc: '24/7 online tracking and detailed inventory management'
    },
    speed: {
      title: 'Fast Response',
      desc: 'Quote within 24 hours and fast operation processes'
    },
    experience: {
      title: 'Experience',
      desc: 'Reliable service in logistics sector since 1974'
    }
  },
  facility: {
    title: 'Facility & Capacity',
    subtitle: 'Modern Infrastructure and Technology',
    totalArea: 'Total 5,000 m² Storage Area',
    customsArea: '2,800 m² Bonded Warehouse',
    freeArea: '2,200 m² Free Zone',
    viewGallery: 'View Our Facility'
  },
  security: {
    title: 'Security & Technology',
    subtitle: 'High Standard Protection',
    camera: {
      title: '24/7 Camera System',
      desc: 'Continuous security monitoring'
    },
    alarm: {
      title: 'Alarm System',
      desc: 'Advanced security infrastructure'
    },
    fire: {
      title: 'Fire Suppression',
      desc: 'Automatic fire suppression system'
    },
    wms: {
      title: 'WMS / ERP Integration',
      desc: 'Online inventory access and management'
    }
  },
  testimonials: {
    title: 'Client Testimonials',
    subtitle: 'Your Trusted Business Partner'
  },
  cta: {
    title: 'Let Us Get Back to You Within 24 Hours',
    subtitle: 'Get a quote now for your logistics needs',
    getQuote: 'Get Quote',
    callUs: 'Call Us'
  },
  contact: {
    hero: {
      title: 'Contact Us',
      subtitle: 'We are here to serve you 24/7. Get in touch with us for your questions.'
    },
    info: {
      title: 'Contact Information',
      description: 'You can contact us for detailed information about our logistics and storage services.',
      address: {
        title: 'Address',
        content: 'Taşocağı Cad. No:26 Mahmutbey 34217 Bağcılar / Istanbul / TURKEY'
      },
      phone: {
        title: 'Phone'
      },
      fax: {
        title: 'Fax'
      },
      email: {
        title: 'Email'
      },
      whatsapp: {
        title: 'WhatsApp'
      },
      workingHours: {
        title: 'Working Hours',
        weekdays: 'Monday - Friday: 08:30 - 17:00',
        saturday: 'Saturday: Closed',
        sunday: 'Sunday: Closed'
      },
      qrCode: 'Scan QR code to contact quickly'
    },
    form: {
      title: 'Write to Us',
      description: 'You can reach us by filling out the form. We will get back to you as soon as possible.',
      name: 'Full Name / Company Name',
      namePlaceholder: 'Enter your name and surname',
      email: 'Email',
      emailPlaceholder: 'example@email.com',
      phone: 'Phone / Your Message',
      phonePlaceholder: 'Your phone number',
      message: 'Your Message',
      messagePlaceholder: 'Write your message here...',
      characters: 'characters',
      submit: 'Send',
      sending: 'Sending...',
      successMessage: 'Your message has been sent successfully! We will get back to you as soon as possible.',
      errorMessage: 'An error occurred. Please try again.'
    },
    map: {
      title: 'Location',
      subtitle: 'You can get directions from the map to visit our facility'
    }
  },
  infoCenter: {
    hero: {
      title: 'Knowledge Center',
      subtitle: 'Get detailed information about customs warehouse regulations and required documents'
    },
    sections: {
      regulations: {
        title: 'Regulations and Directives',
        description: 'Current regulations and directives related to customs warehouse operations'
      },
      notifications: {
        title: 'General Notifications',
        description: 'Official notifications and updates regarding customs warehouse regime'
      },
      forms: {
        title: 'Application Forms',
        description: 'Required forms and documents for warehouse opening and operation'
      }
    },
    documents: {
      download: 'Download',
      viewAll: 'View All'
    }
  },
  footer: {
    contact: 'Contact',
    address: 'Taşocağı Cad. No:26 Mahmutbey 34217 Bağcılar / Istanbul / TURKEY',
    phone: 'Phone',
    fax: 'Fax',
    email: 'Email',
    quickLinks: 'Quick Links',
    workingHours: 'Working Hours',
    weekdays: 'Monday - Friday: 08:30 - 17:00',
    saturday: 'Saturday: Closed',
    sunday: 'Sunday: Closed',
    copyright: '© 2025 Piramit Warehouse & Logistics. All rights reserved.',
    poweredBy: 'Web Design'
  }
};

export default common;